import { render, staticRenderFns } from "./NewsBoostRow.vue?vue&type=template&id=e200d428"
import script from "./NewsBoostRow.vue?vue&type=script&lang=js"
export * from "./NewsBoostRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports